export const suscription = {
  p1: `Verwalten Sie die Details Ihres aktuellen Plans und entdecken Sie Optionen, um Ihr Abonnement zu erweitern oder zu wechseln.`,
  p2: `Jahresplan`,
  p3: `Monatsplan`,
  p4: `Aktiv bis`,
  p5: `Pro Zimmer und Monat`,
  p6: `Pro Unterkunft und Monat`,
  p7: `Belegungszahl`,
  p8: `Pro Platz und Monat`,
  p9: `Abonnement aktualisieren`,
  p10: `Aktive Services`,
  p11: `Aktiv`,
  p12: `Nicht aktiv`,
  p13: `Laden Sie Ihre Gäste ein, den Check-in über WhatsApp zu erledigen, und planen Sie ihn vor ihrer Ankunft in der Unterkunft.`,
  p14: `Bewertungen`,
  p15: `Laden Sie Ihre Gäste ein, ihren Aufenthalt zu bewerten, und stärken Sie den Ruf Ihrer Unterkunft mit positiven Bewertungen.`,
  p16: `Fernzugang`,
  p17: `Erfassen und verwalten Sie Zimmer mit smarten Schlössern. Richten Sie die Zugangscodes ein, die den Gästen bereitgestellt werden.`,
  p18: `Identitätsprüfung`,
  p19: `Wir prüfen die Identität der Gäste, indem wir das Foto auf Ausweis oder Reisepass mit einem Selfie in Echtzeit vergleichen.`,
  p20: `Abonnement und Zahlungsmethoden verwalten`,
  p21: `Karten nach Bedarf hinzufügen oder entfernen`,
  p22: `Ihr aktuelles Abonnement ist kostenlos`,
  p23: `Erweitern Sie Ihr Abonnement, um auf erweiterte Funktionen zuzugreifen.`,
  p24: `Ihr kostenloses Abonnement läuft ab in`,
  p25: `Tag`,
  p26: `Tagen`,
  p27: `Verlieren Sie nicht den Zugang zu erweiterten Funktionen: Erweitern Sie jetzt Ihr Abonnement`,
  p28: `Stellen Sie Ihren Plan mit Zusatzleistungen zusammen`,
  p29: `Belegung`,
  p30: `Monat`,
  p31: `Bewertungen`,
  p32: `Fernzugang`,
  p33: `Zelt`,
  p34: `Villa`,
  p35: `Identitätsprüfung`,
  p36: `GESAMTBELEGUNG`,
  p37: `Die Gesamtbelegung ist die maximal zulässige Personenzahl in allen Ihren Apartments, zum Beispiel (wenn Sie 5 Apartments auswählen, kann Ihre Gesamtbelegung 20 Plätze betragen). Die Angabe der Gesamtbelegung hilft uns, Ihr Abonnement korrekt zu verwalten und die Sicherheitsvorschriften einzuhalten.`,
  p38: `Die Gesamtbelegung ist die maximal zulässige Personenzahl in Ihrer Villa, zum Beispiel (wenn Sie 5 Apartments auswählen, kann Ihre Gesamtbelegung 20 Plätze betragen). Die Angabe der Gesamtbelegung hilft uns, Ihr Abonnement korrekt zu verwalten und die Sicherheitsvorschriften einzuhalten.`,
  p39: `Die Gesamtbelegung ist die maximal zulässige Personenzahl in Ihrem Hotel / Hostel, zum Beispiel (wenn Sie 5 Apartments auswählen, kann Ihre Gesamtbelegung 20 Plätze betragen). Die Angabe der Gesamtbelegung hilft uns, Ihr Abonnement korrekt zu verwalten und die Sicherheitsvorschriften einzuhalten.`,
  p40: `Die Gesamtbelegung ist die maximal zulässige Personenzahl auf Ihrem Campingplatz, zum Beispiel (wenn Sie 5 Apartments auswählen, kann Ihre Gesamtbelegung 20 Plätze betragen). Die Angabe der Gesamtbelegung hilft uns, Ihr Abonnement korrekt zu verwalten und die Sicherheitsvorschriften einzuhalten.`,
  p41: `Sie müssen die Gesamtbelegung Ihrer Unterkünfte angeben.`,
  p42: `WACheckin WhatsApp`,
  p43: `Ihr WhatsApp Business`,
  p44: `pro Platz/Monat`,
  p45: `pro Zimmer/Monat`,
  p46: `Jährlich`,
  p47: `Abonnement aktivieren`,
  p48: `Abonnement aktualisieren`,
  p49: `Ausgewähltes Abonnement`,
  p50: `Anzahl`,
  p51: `Zimmer`,
  p52: `Unterkunft`,
  p53: `Monatspreis pro`,
  p54: `Zimmer`,
  p55: `Unterkünfte`,
  p56: `Ausgewählte Belegungszahl`,
  p57: `Monatspreis pro`,
  p58: `Platz`,
  p59: `Abonnementart`,
  p60: `Jährlich`,
  p61: `Monatlich`,
  p62: `Zusatzleistungen:`,
  p63: `Keine Services hinzugefügt`,
  p64: `Es wird empfohlen, den WhatsApp-Service hinzuzufügen`,
  p65: `Bewertungen`,
  p66: `Gesamtbetrag`,
  p67: `Mit der Zahlung fortfahren`,
  p68: `Abonnement aktualisieren`,
  p69: "ChatBot",
  
  p70: `Abonnement`,
  p71: `Aktiv`,
  p72: `Optionale Zusatzleistungen`,

  p73: `Haben Sie neue Unterkünfte zu verwalten?`,

  p74: `Details zu Ihrer Aktualisierung und den neuen Services`,
  p75: `Die Abrechnung zusätzlicher Services oder Unterkünfte erfolgt anteilig, entsprechend den verbleibenden Tagen des Monats in Ihrem aktuellen Abonnement.`,
  p76: `So zahlen Sie nur für die tatsächliche Nutzungsdauer bis zur Verlängerung Ihres Plans.`,

  p77: `Hinzugefügte Unterkünfte`,
  p78: `Zusatzleistungen`,
  p79: `Fernzugang`,
  p80: `ChatBot KI`,
  p81: `Preis`,
  p82: `Jährlich`,
  p83: `Monatlich`,
  p84: `Abonnement aktualisieren`,

  p85: `Abonnierte Unterkünfte`,
  p86: `Zusatzleistungen`,
  p87: `Keine Zusatzleistungen gebucht`,
  p88: `ChatBot KI`,
  p89: `Fernzugang`,

  p90: `Im Plan enthalten`,

  p91: `Preis pro Jahr`,
  p92: `Preis pro Monat`,

  p93: `Status`,
  p94: `Aktiv`,
  p95: `Läuft ab`,

  p96: `Erfassen und verwalten Sie Zimmer mit smarten Schlössern. Richten Sie die Zugangscodes ein, die den Gästen bereitgestellt werden.`,

  p97: `ChatBot KI`,
  p98: `Fügen Sie den KI-gestützten Chatbot-Service hinzu und beantworten Sie die Anfragen Ihrer Gäste automatisch, schnell und effizient.`,

  p99: `Möchten Sie den Vorgang wirklich fortsetzen?`,
  p100: `Abonnement aktualisieren`,
  
  p101: ``,
  p102: ``,
  p103: ``,
  p104: ``,
  p105: ``,
  p106: ``,
  p107: ``,
  p108: ``,
  p109: ``,
  p110: ``,
  p111: ``,
  p112: ``,
  p113: ``,
  p114: ``,
  p115: ``,

};
